<script setup lang="ts">
import { RouterWrapper } from '@bagelink/vue'
</script>

<template>
  <div>
    <RouterWrapper class="relative" />
  </div>
</template>
